import ReactDOM from 'react-dom/client'
import './index.css'
import Router from './Routers/Router';

const root = document.getElementById('root');
const rootInstance = ReactDOM.createRoot(root);
rootInstance.render(<Router />);